import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_FIELDS,
} from './constants';

const initialState = fromJS({
  form: {
    hasProvincialHealthCoverage: 'false',
    provincialHealthProvince: '',
    hasOtherInsuranceCoverage: 'false',
    otherInsuranceCoverageTypes: [],
    employerInsuranceCompany: '',
    employerPolicyGroupNo: '',
    creditCardProvider: '',
    creditCardFirst4Digits: '',
    creditCardLast4Digits: '',
    creditCardInsuranceProvider: '',
    anotherTravelInsuranceCompany: '',
    anotherTravelPolicyNumber: '',
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  let newState = state;
  fields.forEach((field) => {
    const defaultValue = initialState.getIn(['form', field]);
    newState = newState.setIn(['form', field], defaultValue);
  });
  return newState;
}

function stepOtherInsuranceCoverageTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload ? fromJS({ form: action.payload, errors: [] }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_FIELDS:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default stepOtherInsuranceCoverageTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOtherInsuranceCoverage/reducer.js